import React, { FC } from "react";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as ArrowWhiteIcon } from "src/assets/icons/arrow-right-white-base.svg";
import { Link } from "src/components/Link";
import { PATHNAMES } from "src/constants/routes";

export const AssistanceBlock: FC = () => (
  <div className="flex flex-col justify-center items-center text-center gap-8 p-5 h-full text-green-base lg:w-3/5 lg:p-18 3xl:gap-10">
    <h4 className="hidden lg:flex text-3xl 3xl:text-6xl">
      Нічого не зрозуміло?
    </h4>
    <h3 className="hidden lg:flex text-5xl 3xl:text-80">Потрібна допомога?</h3>
    <p className="3xl:text-24 font-bold text-black-base">
      Заповніть форму, щоб отримати безкоштовну консультацію та відповіді на всі
      питання, повʼязані з вашим бізнесом!
    </p>
    <h3 className="text-24 md:text-5xl 3xl:text-80">Або</h3>
    <p className="3xl:text-24 font-bold text-black-base">
      Розрахуйте приблизну ціну вашої послуги в калькуляторі.
    </p>
    <Link href={PATHNAMES.CALCULATOR} className="w-full lg:w-auto">
      <Button
        variant={ButtonVariants.GREEN}
        className="flex items-center justify-center gap-5 w-full px-5 py-3 text-base md:px-6 md:py-4 3xl:text-24 3xl:px-8 3xl:py-6"
      >
        <span className="flex-1 text-start">Розрахувати</span>
        <ArrowWhiteIcon />
      </Button>
    </Link>
  </div>
);
